// ** Modules
import { useQuery } from '@apollo/client/react';
import { gql, type TypedDocumentNode } from '@apollo/client';

// ** Utils
import { MediaFields } from './fragments';

// ** Types
import type { Query } from '@/types/graphql';

// ** Queries Schemas
export const getPersonById: TypedDocumentNode<Pick<Query, 'relevantPeople_connection'>> = gql`
    ${MediaFields}
    query RelevantPeople_connection(
        $locale: I18NLocaleCode
        $filters: RelevantPersonFiltersInput
    ) {
        relevantPeople_connection(locale: $locale, filters: $filters) {
            nodes {
                team
                sector
                profilePicture {
                    ...MediaFields
                }
            }
        }
    }
`;

//////////////////

// ** Query Functions

// Get Person By Id
export const useGetPersonById = ({ id, locale }: { id?: string | number; locale: string }) => {
	const shouldSkip = id === null || id === '';
	const { loading, error, data } = useQuery(getPersonById, {
		ssr: false,
		variables: { locale, filters: { cobraId: { eq: id } } },
		skip: shouldSkip
	});

	return {
		data: data?.relevantPeople_connection?.nodes[0] ?? null,
		loading,
		error
	};
};
